import { directoryGroups } from "@/mocks/homeData";
import SectionHead from "./SectionHead";

export default function Directory() {
  return (
    <section id="directory" className="scroll-mt-24 bg-background-100 py-10 md:py-14">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <SectionHead
          kicker="list-unordered"
          title="栏目目录 · 全站索引"
          sub="按题材、观点、常驻栏目与时间归档四条线索，帮你把全站目录摊开来看。"
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {directoryGroups.map((g) => (
            <div
              key={g.group}
              className="rounded-xl border border-background-200 bg-background-50 p-4 md:p-5"
            >
              <div className="mb-3 flex items-center gap-2">
                <span className="flex h-7 w-7 items-center justify-center rounded-md bg-secondary-100 text-sm text-secondary-900">
                  <i className="ri-folder-5-line" aria-hidden="true" />
                </span>
                <h3 className="text-sm font-bold text-foreground-950">{g.group}</h3>
              </div>
              <ul className="space-y-2">
                {g.items.map((item) => (
                  <li key={item}>
                    <a
                      href="#tags"
                      className="group flex items-center justify-between rounded-md px-2 py-1 text-[13px] text-foreground-600 hover:bg-background-100 hover:text-foreground-950"
                    >
                      <span className="inline-flex items-center gap-2">
                        <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500" aria-hidden="true" />
                        {item}
                      </span>
                      <span className="font-display text-[10px] text-foreground-300 group-hover:text-foreground-500">
                        浏览
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-6 flex flex-col items-center justify-between gap-3 rounded-xl bg-background-50 px-5 py-4 sm:flex-row md:px-6">
          <p className="flex items-center gap-2 text-sm text-foreground-600">
            <i className="ri-refresh-line text-primary-500" aria-hidden="true" />
            全站内容按时间线自动归档，越久的内容回找越轻松。
          </p>
          <button className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-background-200/70 px-4 py-2 text-xs text-foreground-700 hover:bg-background-200">
            查看完整归档
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </button>
        </div>
      </div>
    </section>
  );
}